import React from 'react'
import { EmptyStubComponent } from '@components/empty-stub-component'
import { getGrammarlyCodaAsset } from './assets/grammarly-coda'

type BackgroundConfig = {
  top: React.FC
  background: React.FC
  bottom: React.FC
}

const BACKGROUNDS: Record<string, () => BackgroundConfig> = {
  grammarlyCoda: getGrammarlyCodaAsset,
}

export const getBackgroundAsset = (backgroundAssetType?: string) => {
  if (!backgroundAssetType || !BACKGROUNDS[backgroundAssetType]) {
    return { top: EmptyStubComponent, background: EmptyStubComponent, bottom: EmptyStubComponent }
  }

  const backgroundAsset = BACKGROUNDS[backgroundAssetType]

  return backgroundAsset()
}
